import React from "react";
import LoginPage from "../modules/auth/LoginPage";

const Login = (): JSX.Element => <LoginPage />;

export default Login;
